import { AssetType, ExtendedAssetType } from '@imcc/transport';
import { buildGraphicSymbolProduct } from './build-graphic-symbol-product';
import { buildImageProduct } from './build-image-product';
import { buildPublicationProduct } from './build-publication-product';
import { ProductProperties } from './product-properties';
import { TagManagerProductDto } from './tag-manager-product.dto';
import { buildOtherProduct } from './build-other-product';

const BUILDER_MAP: {
  [key in ExtendedAssetType]: (properties: ProductProperties) => TagManagerProductDto;
} = {
  [AssetType.Image]: buildImageProduct,
  [AssetType.Publication]: buildPublicationProduct,
  [AssetType.GraphicSymbol]: buildGraphicSymbolProduct,
  [AssetType.StoreCommunication]: buildOtherProduct,
  'motion-media': buildOtherProduct,
  other: buildOtherProduct,
};

export function buildProduct(properties: ProductProperties): TagManagerProductDto {
  return BUILDER_MAP[properties.assetType](properties);
}
